import React, { useEffect, useRef, useState } from "react";

interface ToggleLoadingTextProps {
  texts: string[];
  interval?: number;
  className?: string;
}

/**
 * A self-contained component that cycles through loading texts.
 * This component manages its own state and only re-renders itself,
 * preventing parent component re-renders.
 */
const ToggleLoadingText: React.FC<ToggleLoadingTextProps> = ({
  texts,
  interval = 2000,
  className = "text-xs"
}) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % texts.length);
    }, interval);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [texts.length, interval]);

  return <span className={className}>{texts[currentIndex]}</span>;
};

export default ToggleLoadingText;
